import { render, staticRenderFns } from "./csrf_input.vue?vue&type=template&id=38c8f267&"
import script from "./csrf_input.vue?vue&type=script&lang=js&"
export * from "./csrf_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports